VIV.behaviours.megaMenu = (function () {

    let activeWrappers = null;

    const attach = function (context) {
        const blocks = context.querySelectorAll('.megaMenu');

        if (blocks.length === 0) {
            return;
        }

        blocks.forEach(block => init(block, context));
    };

    const init = function (block, context) {
        const links = block.querySelectorAll('.submenuLinks__link');
        activeWrappers = [block.querySelector('#mega-menu-root')];
        buildBreadcrumb(block);

        block.querySelector('.megaMenu__back').addEventListener('click', (e) => {
            e.preventDefault();
            if (activeWrappers.length > 1) {
                activeWrappers.pop();
                showWrapper(block, activeWrappers[activeWrappers.length - 1]);
                buildBreadcrumb(block);
            }
        });

        links.forEach(link => {
            link.addEventListener('click', (e) => {
                const linkItem = link.parentNode;
                const linkIndex = linkItem.getAttribute('data-index');
                const subMenuWrapper = block.querySelector(`#mega-menu-${linkIndex}`)
                if (subMenuWrapper) {
                    e.preventDefault();
                    activeWrappers.push(subMenuWrapper);
                    showWrapper(block, subMenuWrapper);
                    buildBreadcrumb(block);
                }
            });
        })
    };

    const hideAllWrappers = function (block) {
        const wrappers = block.querySelectorAll('.megaMenu__items');
        wrappers.forEach(wrapper => wrapper.style.display = 'none');
    }

    const showWrapper = function (block, wrapper) {
        hideAllWrappers(block);
        wrapper.style.display = 'block';
    }

    const buildBreadcrumb = function (block) {
        const breadcrumb = block.querySelector('.megaMenu__breadcrumbItems');
        const backlink = block.querySelector('.megaMenu__back');
        backlink.classList.toggle('megaMenu__back--disabled', activeWrappers.length === 1);

        breadcrumb.innerText = '';
        activeWrappers.forEach((element) => {
            const link = document.createElement('a');
            link.innerText = element.getAttribute('data-title');
            link.classList.add('megaMenu__breadcrumbItem');
            breadcrumb.append(link);
            link.addEventListener('click', function () {
                const links = link.parentNode.childNodes;
                const index = Array.from(links).indexOf(link);
                activeWrappers = activeWrappers.slice(0, index + 1);
                showWrapper(block, activeWrappers[activeWrappers.length - 1]);
                buildBreadcrumb(block);
            });
        });
    }

    return {
        attach: attach
    }
})();
